import React, { useState, useEffect } from "react"
import SearchResult from "../../../templates/search-result-template"
import { SearchTitle, PropertySearchURL, hasMyaccount } from "../../../common/constant"
import { UserObjectStoreProvider, getUserobjectData, isAuthenticated } from "@starberry/myaccount-website-utils";

// markup
const SearchResultComp = (props) => {

  // For myaccount
  useEffect(() => {
    if (authuser && hasMyaccount) {
      const getUserObjects = async () => {
          try {
              const userObjects = await getUserobjectData()
              setUserObjects(userObjects.data.data)
          } catch (e) {
              console.log("e:", e)
          }
      }
      getUserObjects()
    }
  }, [])

  const [userObjects, setUserObjects] = useState({});
  const authuser = isAuthenticated()
  

  return (
    <SearchResult 
      title={SearchTitle.residential.lettings} 
      department={"residential"} 
      search_type={"lettings"} 
      status={['To Let', 'Let Agreed']} 
      path={PropertySearchURL["residential"]["lettings"]}
      location={props.location}
      userObjects={userObjects}
    />
  )
}

const PropertToRent = (props) => {
  return(
    <UserObjectStoreProvider>
      <SearchResultComp {...props} />
    </UserObjectStoreProvider>
  )
}


export default PropertToRent